import classnames from "classnames";
import map from "lodash/map";
import size from "lodash/size";
import PropTypes from "prop-types";
import { Component } from "react";
import "./RadioButtonGroup.css";

export default class RadioButtonGroupV3 extends Component {
  static defaultProps = {
    items: [],
  };
  static propTypes = {
    radioButtonValueName: PropTypes.string.isRequired,
    radioButtonTextName: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    id: PropTypes.string,
    label: PropTypes.string,
    radioButtonGroupName: PropTypes.string,
    selectedValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
    ]),
    validationError: PropTypes.string,
  };
  render() {
    const {
      radioButtonValueName,
      radioButtonTextName,
      label,
      id,
      radioButtonGroupName,
      items,
      onChange,
      selectedValue,
      validationError,
    } = this.props;
    if (size(items) === 0) return <div />;
    return (
      <div
        className={classnames("mb-3 radiobuttongroup", {
          "has-error": validationError,
        })}
        id={id}
      >
        <label className="control-label" htmlFor={radioButtonGroupName}>
          {label}
        </label>

        {map(items, (i) => {
          const radioButtonId = `${radioButtonGroupName}-radiobutton-${i[radioButtonTextName]}`;
          const radioButtonContainerId = `${radioButtonId}-container`;
          return (
            <div key={radioButtonContainerId} id={radioButtonContainerId}>
              <input
                id={radioButtonId}
                className={`${radioButtonGroupName}-input`}
                type="radio"
                name={radioButtonGroupName}
                value={i[radioButtonValueName]}
                onChange={onChange}
                checked={
                  String(i[radioButtonValueName]) === String(selectedValue)
                }
              />
              <span>{i[radioButtonTextName]}</span>
            </div>
          );
        })}
        {validationError && validationError.length > 0 && (
          <span className="help-block">{validationError}</span>
        )}
      </div>
    );
  }
}
